/**
 * TrueRoots — Brand Tokens
 * Single source of truth for colours + spacing that the entire app reads.
 * When the official brand guide arrives, update ONLY the values below.
 * No component code needs to change.
 */
export const brand = {
  name: "TrueRoots One",
  legal: "TrueRoots Agro Foods LLP",
  tagline: {
    en: "From farmer's roots, to your table.",
    hi: "किसान की जड़ों से, आपकी थाली तक।",
    mr: "शेतकऱ्याच्या मुळांपासून, तुमच्या ताटापर्यंत.",
  },
  logo: {
    // Official TrueRoots Agro Foods LLP branding — installed via Sprint 2.
    src: "/branding/logo.png",         // full-colour horizontal mark (light backgrounds)
    srcDark: "/branding/logo-dark.png", // light/white version (dark backgrounds — footer, product hero)
    favicon: "/branding/favicon-64.png",
    fallbackText: "TrueRoots.One",
    // Whether the mark file already includes the wordmark. Set to true only if
    // the drop-in image is a horizontal lockup that contains "TrueRoots.One".
    // Round 3 Part A #1.1: TrueRoots One name MUST be visible in the header alongside
    // the raster mark. The current raster is a circular seal + tagline, without the
    // "TrueRoots One" wordmark, so we render the wordmark in React.
    includesWordmark: false,
  },
  colors: {
    // Primary palette
    deepGreen: "#064E3B",
    deepGreenDark: "#053A2C",
    // Citrus accents
    zestOrange: "#F97316",
    citrusYellow: "#FBBF24",
    lime: "#84CC16",
    // Neutrals
    bone: "#F8FAF8",
    sage: "#D1FAE5",
    text: "#064E3B",
    muted: "#4B5563",
  },
};
